export default __webpack_public_path__ + "static/media/wickedbolt.0554aebc.png";